import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { Icon } from 'src/components/Icon';
import { Skeleton } from 'src/components/Skeleton';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

import { ActionsList } from './ActionsList';
import {
  blockingReasonBodySx,
  blockingReasonIconSx,
  blockingReasonRowSx,
} from './blockingReasonStyles';

export function BlockingReasonRow({
  title,
  message,
  actions,
}: {
  title: string;
  message: string;
  actions?: ButtonPropsWithLabel[];
}) {
  return (
    <Stack direction="row" spacing={1} sx={blockingReasonRowSx}>
      <Icon
        icon={faExclamationCircle}
        size="small"
        sx={blockingReasonIconSx}
      />

      <Stack spacing={0} sx={blockingReasonBodySx}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2">{message}</Typography>
      </Stack>

      {!!actions && (
        <Stack direction="row" spacing={1.5} alignItems="center">
          <ActionsList actions={actions} />
        </Stack>
      )}
    </Stack>
  );
}

export function BlockingReasonFallback() {
  return (
    <Stack direction="row" spacing={1} sx={blockingReasonRowSx}>
      <Icon
        icon={faExclamationCircle}
        size="small"
        sx={blockingReasonIconSx}
      />
      <Stack spacing={0} sx={blockingReasonBodySx}>
        <Skeleton variant="text" width="50%" height={24} />
        <Skeleton variant="text" width="70%" height={24} />
      </Stack>
    </Stack>
  );
}
